module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Role-Models",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60,55 C55.127024,55 13.3021113,55 10,55 C10,43.8366699 14.1764427,34.2923521 24.1662077,30.4365191 C23.1158447,29.284668 20.0156657,25.7830811 20.0156657,20.0223796 C20.0156657,13.3143916 25.6017125,5 35,5 C43.7435452,5 49.9338786,12.3539225 49.9338786,20.0223796 C49.9338786,26.9734701 45.8765671,30 45.8765671,30.4549123 C55.8335853,34.3226378 60,43.8543791 60,55 Z M25.8078182,44.7023878 C28.5551504,44.7023878 30.7823032,42.475235 30.7823032,39.7279029 C30.7823032,36.9805707 28.5551504,34.753418 25.8078182,34.753418 C23.0604861,34.753418 20.8333333,36.9805707 20.8333333,39.7279029 C20.8333333,42.475235 23.0604861,44.7023878 25.8078182,44.7023878 Z M21.8282303,44.2049393 L21.8282303,51.6666667 L25.8078182,49.6768727 L29.7874062,51.6666667 L29.7874062,44.2049393 C28.71454,45.1998363 27.3880107,45.6972848 25.8078182,45.6972848 C24.2276258,45.6972848 22.9010965,45.1998363 21.8282303,44.2049393 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d52d060"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/role_models.vue
// module id = 606
// module chunks = 1